/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CommonTransactionApprovalCard from "../../../../components/_utils/CommonTransactionApprovalCard";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import TaxAccountDetailsPopup from "../../../../components/Accounts/TaxAccount/TaxAccountDetailsPopup/index.jsx";
import { addLifeCycleStatus } from "../../../../components/CommonTimeLineCard";
import Loader from "../../../../components/Loader/Index";
import TaxTransactionDetailsPopup from "../../../../components/Transactions/TaxTransaction/TaxTransactionDetailsPopup/index.jsx";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import {
  getOwnerAccBalance,
  setshowsuccestoast,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  approveTdsTransaction,
  fetchTdsTransactionActionable,
  rejectTdsTransaction,
} from "../../../../redux/features/transactions/taxTransaction/taxTransactionApproval";
import { fetchTdsTransactionDetails } from "../../../../redux/features/transactions/taxTransaction/taxTransactionDetails";
import {
  taxTxnNewAddLabel,
  taxTxnRemoveLabel,
} from "../../../../redux/features/transactions/taxTransaction/taxTransactionViewAll";
import accountNameStandardised from "../../../../utils/accountNamestandardised.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  RejectReasonLength,
} from "../../../../utils/configurationProvider";
import TEXT from "../../../../utils/globalText.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";

const ApprovalGreen = ICONS.APPROVED_GREEN_LINEAR;
const CloseGreyCircleIcon = ICONS.CLOSE_WITH_GREY_CIRCLE;
const QueuedIcon = ICONS.QUEUED;
const DeclinedRed = ICONS.REJECTED_RED;
const PendingIcons = ICONS.PENDING;
const FailedToAction = ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE;

const TaxationTransactionSingleApproval = () => {
  const filterRef = useRef(null);
  const filterBGRef = useRef(null);
  const filterParentDivRef = useRef(null);
  const cardRefs = useRef({});
  const labelActionDispatchedRef = useRef(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  //Selectors
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const { tdsTransactionActionableData } = useSelector(
    (state) => state.tdsTransactionApproval,
  );
  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams(
    location?.state?.approvalStatus
      ? {
          lifecycle: location.state.approvalStatus,
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: PaginationConfiguration.paginationOptions[0],
        }
      : {
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: PaginationConfiguration.paginationOptions[0],
        },
  );

  const [page, setPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [showPopup, setShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [declineReason, setDeclineReason] = useState("");
  const [taxSection, setTaxSection] = useState("");
  const [accountbalancestate, setaccountbalancestate] = useState(
    searchParam.get("sort") || "",
  );
  const [showLoader, setShowLoader] = useState(false);
  const [loading, setLoading] = useState({});
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [taxTxnDetailsId, SetTaxTxnDetailsId] = useState("");
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [allTaxTxndata, setAllTaxTxndata] = useState([]);
  const [allTaxTxnLoading, setAllTaxTxnLoading] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [label, setlabel] = useState(searchParam.get("category") || "");
  const [showTaxDetailPop, setShowTaxDetailPop] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [isLabelPopupOpen, setisLabelPopupOpen] = useState(false);
  const [filteredData, setfilteredData] = useState([]);
  const [txnlabels, settxnLabels] = useState([]);
  const [labeltxnid, setLabeltxnid] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [timelineTxnDetails, setTimelineTxnDetails] = useState([]);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);

  // FilteredSearchField states
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [approvalBtnClicked, setApprovalBtnClicked] = useState("none");

  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const showLoadingToast = (txt) => {
    CommonToast({
      text: txt,
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleReject = async (id, reason) => {
    try {
      if (
        services?.find(
          (service) => service === "ATDSTransaction" || service === "Admin",
        ) === undefined
      ) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "ATDSTransaction, Admin" },
        });
        return;
      }

      // Token check
      if (!sessionStorage.getItem("q2p_token")) {
        return;
      }

      setShowLoader(true);

      showLoadingToast("Rejecting transaction");

      const result = await dispatch(
        rejectTdsTransaction({
          id,
          accountIdData: declineReason,
        }),
      );

      const payload = result?.payload;

      // wait for loader animation
      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (payload?.errors?.user_unauthorized?.[0]) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "ATDSTransaction, Admin" },
        });
        return;
      }

      const updatedData = allTaxTxndata?.map((item) => {
        if (item.txn_id !== id) return item;

        const tx = payload?.transactions?.[0];
        let lifecycleStatus = "error";
        let errorMessage = "";

        if (payload?.status === true) {
          lifecycleStatus =
            tx?.lifecycle_status === "rejected"
              ? "rejected"
              : tx?.lifecycle_status === "pending"
                ? "pendingOne"
                : "error";
        }

        if (payload?.errors?.base?.[0]?.errors) {
          errorMessage = payload.errors.base[0].errors[0];
        } else if (payload?.errors?.base?.[0]) {
          errorMessage = payload.errors.base[0];
        }

        return {
          ...item,
          lifecycle_status:
            item.lifecycle_status === "pending" && payload?.status === true
              ? lifecycleStatus
              : "error",
          rejected: true,
          rejection_reason: reason,
          error: payload?.status === false ? "true" : "false",
          message: payload?.status === false ? errorMessage : "",
        };
      });

      updateAllTxn(updatedData);

      if (payload?.status === false) {
        CommonToast({
          text:
            payload?.errors?.base?.[0]?.errors?.[0] ||
            payload?.errors?.base?.[0] ||
            "Error occurred",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setDeclineReason("");
      } else {
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setShowPopup(false);
        setDeclineReason("");
      }
    } catch (error) {
      console.error("Reject txn failed:", error);

      CommonToast({
        text: "Something went wrong. Please try again.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setShowLoader(false);
      setApprovalBtnClicked((p) => {
        return {
          ...p,
          [deniedId]: "none",
        };
      });
    }
  };

  const fetchSearchDropdownData = async () => {
    setLoadingData(true);

    if (active === "Labels") {
      const available = JSON.parse(
        sessionStorage.getItem("taxTxnAvailableLabels") || "[]",
      );

      const filtered = available.filter((l) =>
        l.toLowerCase().includes(searchUserTextDebounce.toLowerCase()),
      );

      setInputData(filtered.map((l) => ({ id: l, Label: l })));
    }
    // if (active === "Tax section") {
    //   let response = await dispatch(
    //     getTaxSections({
    //       section_name: searchUserTextDebounce,
    //     }),
    //   );
    //   const sections = response?.payload;

    //   if (Array.isArray(sections)) {
    //     let data = sections.map((itm) => ({
    //       id: itm?.section_name,
    //       Tax_section_name: itm?.section_name,
    //       Description: itm?.description || "Not given",
    //     }));

    //     setInputData(data);
    //   }
    // }
    // if (active === "Tax type") {

    //   setInputData(
    //     TAX_OPTIONS.map((c) => ({
    //       id: c.name,
    //       Category: c.name,
    //       Description: c.description || "Not given",
    //     })),
    //   );
    // }

    setLoadingData(false);
  };

  const handleClearFilters = () => {
    setCurrentCategory("");
    setLabelSearchText([]);
    setSearchUserTextDebounce("");
    setSelectedLabels([]);
    setTaxSection("");
    setaccountbalancestate("");
    setlabel("");
    setPage(GlobalConfiguration.lengthCheckOne);
    const keepPagesize =
      searchParam.get("pagesize") ||
      PaginationConfiguration.paginationOptions[0];
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${keepPagesize}`,
      },
      { replace: true },
    );
  };

  const onMount = async () => {
    setAllTaxTxnLoading(true);

    await dispatch(
      fetchTdsTransactionActionable({
        labels: LabelSearchText ?? undefined,
        // tax_section: taxSection,
        sort_by:
          accountbalancestate === "Oldest first"
            ? "oldest"
            : accountbalancestate === "Amount : Low to high"
              ? "ascending"
              : accountbalancestate === "Amount : High to low"
                ? "descending"
                : "latest",
      }),
    )
      .then((response) => {
        const newData = (response?.payload?.transactions || []).map(
          (account) => ({
            ...account,
            loading: false,
            error: "false",
            message: "",
            last_updated_user_id_check: "false",
            distribution_lifecycle_status: "",
          }),
        );
        setAllTaxTxndata(newData);
        setMainData(response?.payload);
        setfilteredData(response?.payload?.transactions ?? []);
        setAllTaxTxnLoading(false);
      })

      .catch(() => {
        setAllTaxTxnLoading(false);
      });
  };

  const handleClose = () => {
    setisLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setAllTaxTxnLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      taxTxnNewAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (taxTxnNewAddLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await onMount();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (taxTxnNewAddLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllTaxTxnLoading(false);
    if (taxTxnNewAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setAllTaxTxnLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      taxTxnRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (taxTxnRemoveLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await onMount();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (taxTxnRemoveLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllTaxTxnLoading(false);
    if (taxTxnRemoveLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const openBeneTxnDetailModal = () => {
    setShowTaxDetailPop(true);
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handlePagination = (pageNum) => {
    handleSubmit("pageno", pageNum);
    setPage(pageNum);
  };

  const closeBeneTxnDetailModal = () => {
    setShowTaxDetailPop(false);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const handleRefresh = async (e, id, prevBalance) => {
    if (services?.includes("VAccountBalance") || services?.includes("Admin")) {
      e.stopPropagation();
      try {
        let response = await dispatch(getOwnerAccBalance(id));

        if (response?.payload?.status === true) {
          let data = allTaxTxndata?.map((item) => {
            if (
              response?.payload.owner_accounts[0].owner_account_id ===
              item.owner_account_id
            ) {
              return {
                ...item,
                owner_account_balance_last_fetched_at_in_words:
                  response.payload.owner_accounts[0]
                    .owner_account_balance_last_fetched_at_in_words,
                owner_account_balance:
                  response.payload.owner_accounts[0].owner_account_balance,

                owner_account_balance_last_fetched_at:
                  response.payload.owner_accounts[0]
                    .owner_account_balance_last_fetched_at,
              };
            }
            return item;
          });
          setAllTaxTxndata(data);
          setTimeout(() => {
            CommonToast({
              text: "Balance refreshed successfully.",
              icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
              variant: "var(--processing)",
              buttonNeeded: false,
            });

            dispatch(setshowsuccestoast());
          }, IntervalConfiguration.intervalExtraSmall);
        } else if (response?.payload?.response) {
          setTimeout(() => {
            toast.dismiss();
            CommonToast({
              text: response?.payload?.response?.data?.errors?.base[0],
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
          }, IntervalConfiguration.intervalMid);
        } else {
          setTimeout(() => {
            toast.dismiss();
            CommonToast({
              text: response?.error.message,
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
          }, IntervalConfiguration.intervalMid);
        }
      } catch (error) {
        CommonToast({
          text: error,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        throw error;
      }
    } else {
      e.stopPropagation();
      navigate("/feature_not_assigned");
    }
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Transaction approved successfully.",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--success)",
      buttonNeeded: false,
    });
  };

  const SideDrawerOpen = async (id, txnId) => {
    SetTaxTxnDetailsId(id);
    setisDrawerOpen(true);
  };

  const updateAllTxn = (updatedTxn) => {
    setAllTaxTxndata(updatedTxn);
  };

  const handleTxnApproval = async (id) => {
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));

    CommonToast({
      text: "Approving transaction",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
    });

    const data = await dispatch(approveTdsTransaction(id));

    let errorMessage = "";
    let lifecycleStatus = "";
    let distributionStatus = "";
    if (data?.payload?.status === errorcode.errorFailed) {
      lifecycleStatus = "pending";
      CommonToast({
        text: data?.payload?.error,
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setApprovalBtnClicked((p) => {
        return {
          ...p,
          [id]: "none",
        };
      });
    }
    if (data?.payload?.errors?.user_unauthorized?.[0]) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "ATDSTransaction",
          },
        });
      }, IntervalConfiguration.intervalExtraLarge);
      setApprovalBtnClicked((p) => {
        return {
          ...p,
          [id]: "none",
        };
      });
    } else if (data.payload.status !== errorcode.errorNotFound) {
      const updatedData = allTaxTxndata?.map((item) => {
        if (item.txn_id === id) {
          if (
            data.payload.status === true &&
            data.payload.transactions[0].lifecycle_status === "approved"
          ) {
            lifecycleStatus = data.payload.transactions[0].lifecycle_status;
            distributionStatus =
              data.payload.transactions[0].distribution_lifecycle_status;
          } else if (data?.payload?.errors) {
            errorMessage =
              data?.payload?.errors?.[0]?.reason || "Something went wrong";
            CommonToast({
              text: errorMessage,
              icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
              variant: "var(--error)",
              buttonNeeded: false,
            });
          } else if (
            data?.payload?.errors?.base[0]?.errors &&
            data?.payload?.errors?.base[0]?.errors[0]?.reason
          ) {
            errorMessage = data.payload.errors.base[0].errors[0].reason;
            if (
              data?.payload?.errors?.base[0]?.errors[0]?.reason.length >=
              GlobalConfiguration.lengthCheckOne
            ) {
              let msgs = data?.payload?.errors?.base[0]?.errors[0]?.reason;
              errorMessage = msgs;

              if (data?.payload?.status === false) {
                CommonToast({
                  text: msgs,
                  icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
                  variant: "var(--error)",
                  buttonNeeded: false,
                });
              }
            }
          } else if (
            data?.payload?.errors?.base[0]?.errors &&
            data?.payload?.errors?.base[0]?.errors[0]?.reason
          ) {
            errorMessage =
              data.payload.errors.base[0].errors[0].reason ||
              data.payload.errors.base[0].errors[0].reason[0];
            if (
              data?.payload?.errors?.base[0]?.errors.length >
              GlobalConfiguration.lengthCheckOne
            ) {
              let msgs = data.payload.errors.base[0].errors[0].reason;

              CommonToast({
                text: msgs,
                icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }
            if (
              data?.payload?.errors?.base[0]?.errors.length >=
              GlobalConfiguration.lengthCheckOne
            ) {
              let msgs = data.payload.errors.base[0].errors[0].reason;
              errorMessage = msgs;
            }
          } else if (data?.payload?.errors?.base[0]) {
            errorMessage = data.payload.errors.base[0];
            setTimeout(() => {
              CommonToast({
                text: errorMessage,
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                btnProps: {
                  isDisabled: false,
                  enabledTextColor: "var(--text-primary)",
                  enabledBgColor: "var(--primary-bg)",
                },
              });
            }, IntervalConfiguration.intervalExtraLarge);
          } else if (
            data.payload.status === true &&
            data.payload.transactions[0].lifecycle_status === "pending"
          ) {
            lifecycleStatus = "pendingOne";
          }

          return {
            ...item,
            last_updated_status:
              item.last_updated_status === "Created" &&
              data?.payload.status === true &&
              data.payload.transactions[0].last_updated_status === "Approved"
                ? "Approved"
                : "Created",

            lifecycle_status:
              data?.payload.status === true &&
              item.lifecycle_status === "pending"
                ? lifecycleStatus
                : "error",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data?.payload.status === false
                ? errorMessage
                : "",

            last_updated_user_id_check:
              item.last_updated_user_id_check === "false" &&
              data.payload.status === true &&
              loginid.employees.id ===
                data.payload.transactions[0].last_updated_user_id
                ? "true"
                : "false",
            distribution_lifecycle_status:
              item.distribution_lifecycle_status === "" &&
              data?.payload.status === true
                ? distributionStatus
                : "",
          };
        }
        setApprovalBtnClicked((p) => {
          return {
            ...p,
            [id]: "none",
          };
        });
        setLoading((prevLoadingStates) => ({
          ...prevLoadingStates,
          [id]: false,
        }));
        return item;
      });

      setAllTaxTxndata(updatedData);
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
      toast.dismiss();
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (
        data?.payload?.status === true &&
        data.payload.transactions[0].lifecycle_status === "approved"
      ) {
        handleApprovalToastSuccess();
      }
      if (data.payload.status === errorcode.errorNotFound) {
        CommonToast({
          text: data.payload.error,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const handleFilterCategory = () => {
    setCurrentCategory(label);
    setLabelSearchText(selectedLabels);
    setAllTaxTxndata([]);
    if (page === GlobalConfiguration.lengthCheckOne) {
      setAllTaxTxnLoading(true);
    }
    setFilterOpen(false);
  };
  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setPage(GlobalConfiguration.lengthCheckOne);
  };

  const hasAnyFilter =
    (currentCategory &&
      currentCategory.length > GlobalConfiguration.lengthCheckZero) ||
    (LabelSearchText &&
      LabelSearchText.length > GlobalConfiguration.lengthCheckZero) ||
    (searchUserTextDebounce &&
      searchUserTextDebounce.length > GlobalConfiguration.lengthCheckZero);

  const noTransactionsFromAPI =
    !allTaxTxnLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allTaxTxnLoading &&
    allTaxTxndata?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const getDistributionTitle = (status) => {
    switch (status) {
      case "distribution_complete":
        return "Distribution completed!";
      case "approved":
        return "Distribution approved";
      case "created":
        return "Distribution created";
      case "awaiting_funds":
        return "Distribution awaiting funds";
      case "distribution_pending":
        return "Distribution pending";
      case "distribution_initiated":
        return "Distribution initiated";
      case "rejected":
        return "Distribution rejected";
      case "reversal":
        return "Distribution reversal";
      case "denied":
        return "Distribution denied";
      case "abandoned":
        return "Distribution abandoned";
      case "failed":
        return "Distribution failed";
      default:
        return "Unknown error";
    }
  };

  const getDistributionSubtext = (status) => {
    switch (status) {
      case "distribution_complete":
        return "This transaction has been verified and settled.";
      case "approved":
        return "The distribution for this transaction has been approved.";
      case "created":
        return "This transaction has been approved and is set for distribution";
      case "awaiting_funds":
        return "This transaction has been approved and awaiting for funds.";
      case "distribution_pending":
        return "The distribution for this transaction has been pending.";
      case "distribution_initiated":
        return "This transaction has been approved and the distribution is initiated.";
      case "rejected":
        return "The distribution for this transaction has been rejected.";
      case "denied":
        return "The distribution for this transaction has been denied.";
      case "reversal":
        return "The distribution for this transaction has been reversed.";
      case "failed":
        return "The distribution for this transaction has failed.";
      default:
        return "An error occurred while taking action on this transaction.";
    }
  };

  const getDistributionIcon = (status) => {
    switch (status) {
      case "created":
      case "approved":
      case "awaiting_funds":
      case "distribution_initiated":
      case "distribution_pending":
        return QueuedIcon;

      case "distribution_complete":
        return ApprovalGreen;

      case "rejected":
      case "failed":
      case "reversal":
      case "denied":
        return DeclinedRed;

      case "abandoned":
        return CloseGreyCircleIcon;
      default:
        return null;
    }
  };

  const getTxnOverlayConfig = ({
    account,
    loading,
    openTxn,
    openAccountDrawer,
    openTxn2,
  }) => {
    const isError =
      account.lifecycle_status === "error" &&
      account.error === "true" &&
      !loading[account.txn_id];

    const isRejected =
      account.lifecycle_status === "rejected" &&
      account.error === "false" &&
      !loading[account.txn_id];

    const isAccountApprovalPending =
      account.lifecycle_status === "pending" &&
      account.tds_account_approval_status === "pending" &&
      !loading[account.txn_id];

    const isTxnApprovalPending =
      (account.lifecycle_status === "pending" || loading[account.txn_id]) &&
      account.tds_account_approval_status === "approved";

    const isSecondApprovalPending =
      account.last_updated_user_id_check === "true" &&
      account.lifecycle_status === "pendingOne" &&
      account.error === "false" &&
      !loading[account.txn_id];

    const hasAccountApprovalAccess = services?.includes("ATDSTransaction");

    const isDistributionState =
      account.lifecycle_status === "approved" &&
      [
        "created",
        "approved",
        "reversal",
        "denied",
        "awaiting_funds",
        "distribution_initiated",
        "distribution_pending",
        "rejected",
        "abandoned",
        "failed",
        "distribution_complete",
      ].includes(account.distribution_lifecycle_status) &&
      account.error === "false" &&
      !loading[account.txn_id];

    if (isError) {
      return {
        cardState: "single",
        overlay1Icon: FailedToAction,
        overlay1Text: "Failed to take action!",
        overlay1Subtext: account.message,
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        overlay1Cta1Color: "var(--negative-act)",
        allowApproveReject: false,
      };
    } else if (isRejected) {
      return {
        cardState: "double",
        overlay1Icon: DeclinedRed,
        overlay1Text: "Rejected",
        overlay1Subtext: "This transaction has been rejected",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        overlay2Text: account.rejection_reason,
        overlay2Subtext: "Rejected reason",
        allowApproveReject: false,
      };
    } else if (isAccountApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: null,
        overlay1Text: "Account approval pending",
        overlay1Subtext:
          "Account is not approved, please approve account before approving transaction.",
        overlay1CtaText: "Approve account",
        overlay1SubtextColor: "var(--pending)",
        overlay1CtaOnClick: () => {
          if (hasAccountApprovalAccess) {
            openAccountDrawer();
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "BAAccount, BVAccount" },
            });
          }
        },

        allowApproveReject: false,
      };
    } else if (isSecondApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: PendingIcons,
        overlay1IconColor: "var(--pending)",
        overlay1Text: "Pending",
        overlay1Subtext:
          "This transaction has been approved and requires another user's approval before distribution.",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        allowApproveReject: false,
      };
    } else if (isDistributionState) {
      return {
        cardState: "single",
        overlay1Icon: getDistributionIcon(
          account.distribution_lifecycle_status,
        ),
        overlay1Text: getDistributionTitle(
          account.distribution_lifecycle_status,
        ),
        overlay1Subtext: getDistributionSubtext(
          account.distribution_lifecycle_status,
        ),
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        allowApproveReject: false,
      };
    } else if (isTxnApprovalPending) {
      return {
        cardState: "default",
        allowApproveReject:
          (services?.includes("VTDSTransaction") &&
            services?.includes("ATDSTransaction")) ||
          services?.includes("Admin"),
      };
    } else {
      return {
        cardState: "default",
        allowApproveReject: false,
      };
    }
  };

  const PopupcloseIcons = () => {
    setOpenApprovalTimeline([]);
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
    setTimelineTxnDetails([]);
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const OpenTimeline = async (id) => {
    SetopenTimelinePopup(true);
    setShowApprovalTimeline(true);

    const details = await dispatch(fetchTdsTransactionDetails(id));

    if (details?.payload?.transaction) {
      let request = structuredClone(details.payload.transaction?.[0]);
      request.statusName =
        details.payload.transaction[0]?.lifecycle_status === "pending"
          ? "Require approval"
          : "pending";
      request.statusColor =
        details.payload.transaction[0]?.lifecycle_status === "pending"
          ? "text-pending"
          : "text-text-primary";

      const uiState = addLifeCycleStatus({
        lifecycle_status: details.payload?.transaction[0]?.lifecycle_status,
        distribution_lifecycle_status:
          details.payload?.transaction[0]?.distribution_lifecycle_status,
        services,
      });

      setTimelineTxnDetails([
        {
          ...request,
          ...uiState,
        },
      ]);
    }
  };

  useEffect(() => {
    if (active) fetchSearchDropdownData();
  }, [active]);

  useEffect(() => {
    onMount();
  }, [
    page,
    pageSize,
    currentCategory,
    LabelSearchText,
    accountbalancestate,
    markerData,
  ]);

  useEffect(() => {
    if (isLabelPopupOpen) {
      const availableLabels = JSON.parse(
        sessionStorage.getItem("taxTxnAvailableLabels") || "[]",
      );
      settxnLabels(availableLabels);
    }
  }, [isLabelPopupOpen]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && filterOpen) {
        handleFilterCategory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [label, selectedLabels, filterOpen]);

  useEffect(() => {
    const handleFilter = (e) => {
      if (
        filterBGRef.current &&
        filterBGRef.current.contains(e.target) &&
        filterParentDivRef.current &&
        !filterParentDivRef.current.contains(e.target)
      ) {
        setFilterOpen(false);
      }
    };

    document.addEventListener("click", handleFilter);

    return () => {
      document.removeEventListener("click", handleFilter);
    };
  }, [filterBGRef, filterRef]);

  useEffect(() => {
    if (label === "") {
      setCurrentCategory("");
    }
  }, [label]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, IntervalConfiguration.intervalExtraSmall);
    }
  }, [ownerAccBalanceLoading]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };
  return (
    <>
      {!(noTransactionsFromAPI || noResultsAfterFilter) && (
        <div
          className={`fixed w-full ${allTaxTxnLoading ? "hidden" : "block"} bottom-bottom-base z-z-index-tooltip`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={mainData}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={page}
            setIsOpen={() => {}}
          />
        </div>
      )}
      {showTaxDetailPop && (
        <div
          className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneTxnDetailModal();
          }}
        >
          <TaxTransactionDetailsPopup
            closePopup={() => {
              setShowTaxDetailPop(false);
            }}
            transactionHeader={"Tax transaction details"}
            tax_txn_id={txnId}
            typePopup={true}
            typeSingle={true}
          />
        </div>
      )}
      {isDrawerOpen && (
        <div
          className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneAccountDetailModal();
          }}
        >
          <TaxAccountDetailsPopup
            closeBeneAccountDetailModal={() => {
              setisDrawerOpen(false);
            }}
            headerTitle={"Tax account details"}
            tax_account_id={taxTxnDetailsId}
            type="tax_account_detail_modal"
          />
        </div>
      )}
      {isLabelPopupOpen && (
        <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={txnlabels}
            setLabels={settxnLabels}
            LabelAccounts={labeltxnid}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={(filteredData || [])
              ?.filter((t) => labeltxnid?.includes(t?.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleClose}
            loading={allTaxTxnLoading}
            setLoading={setAllTaxTxnLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {opentimelinepopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Transaction timeline"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            headertextSize="font-md"
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={PopupcloseIcons}
            closeicon="https://q2pay.in/new_assets/common/create_flow/close.svg"
            closeiconhoverOption="white"
            closeiconbtnType="button"
            closeiconisDisabled={false}
            closeicondisabledBgColor=""
            closeiconbuttonRef={null}
            closeicontitle="Close"
            btnType="button"
            handleFunction={() => {}}
            enabledBgColor="var(--positive-act)"
            hoverOption="dark"
            outLineColor=""
            enabledTextColor="var(--text-primary)"
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor=""
            disabledBgColor=""
            isLoading={false}
            buttonRef={null}
            inActiveVariantNeeded={false}
            isLoaderNeeded={false}
            isscrollRequired={true}
          >
            <TimelinePopupContent
              logsData={timelineTxnDetails}
              showDistributionRightIcon={false}
              showApprovalLeftIcon={false}
              handleApprovalClick={() => {}}
              showApprovalTimeline={showApprovalTimeline}
              openApprovalTimeline={openApprovalTimeline}
              handleApprovalTimeline={handleApprovalTimeline}
              setOpenApprovalTimeline={setOpenApprovalTimeline}
              cardType={"double"}
              popUpMode={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPopup && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          {" "}
          <SmallPopupWithInput
            headerTitle={TEXT.REJECT_REASON_LABEL}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle={TEXT.REJECTION_REASON_PROMPT}
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            inputPlaceholder={TEXT.REASON_10_150_CHAR}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText={TEXT.CANCEL}
            btnOneHandleFunction={() => {
              setApprovalBtnClicked((p) => {
                return {
                  ...p,
                  [deniedId]: "none",
                };
              });
              if (!showLoader) {
                handleClosePopup();
                setDeclineReason("");
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneIsDisabled={showLoader}
            btnTwoText={TEXT.REJECT}
            btnTwoHandleFunction={() => {
              if (
                !declineReason ||
                declineReason.length <
                  GlobalConfiguration.owneraccountnormalLength ||
                showLoader
              ) {
                return;
              }
              handleReject(deniedId, declineReason);
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length <
                GlobalConfiguration.owneraccountnormalLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      <div className="flex flex-col w-width-full h-screen bg-primary-bg pb-pagination-height">
        <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>
        <div className="flex flex-col items-center justify-center shadow-box-shadow-bottom bg-primary-nav w-full-width z-z-index-overlay relative">
          <TopNavComponent
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={undefined}
            handleBack={() => navigate(GlobalConfiguration?.navigate_back)}
            topNavCtaBtn2Needed={false}
            BottomHeader={"Post Approval Process"}
            BottomSubText={
              "Once approved, transaction distribution will get created and auto settled using selected source account. If there are insufficient funds, the transaction will settle once the source account is refilled, and distribution will be initiated thereafter."
            }
            isSelectionView={false}
            isToggleNeeded={true}
            toggleProps={{
              state: true,
              title: "Multi approval",
              isDisabled: false,
              handleClick: () => {
                navigate(
                  "/tax_transaction_dashboard/tax_transaction_multi_select",
                );
                // CommonToast({
                //   text: "Feature coming soon",
                //   icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                //   variant: "var(--coming-soon)",
                //   buttonNeeded: false,
                // });
              },
            }}
            assignLabelNeeded={false}
            assignTagNeeded={false}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: false,
              isSearchDisabled: allTaxTxnLoading
                ? true
                : allTaxTxnLoading
                  ? true
                  : false,
              onSearchInput: (val) => setSearchUserTextDebounce(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search tax transaction",
              filterPlaceholder: "Category / Labels",
              filterItems: [
                // {
                //   name: "Tax type",
                //   short_name: "Typ - TDS",
                //   isMulti: false,
                //   value: currentCategory,
                //   setValue: (val) => {
                //     setPage(GlobalConfiguration.lengthCheckOne);
                //     handleSubmit("category", val);
                //     setCurrentCategory(val);
                //   },
                //   isDropdown: true,
                // },
                // {
                //   name: "Tax section",
                //   short_name: "Sec",
                //   valueType: "string",
                //   isMulti: false,
                //   value: taxSection,
                //   setValue: (val) => {
                //     setTaxSection(val);
                //   },
                //   isDropdown: true,
                //   isDisabled: false,
                // },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    setPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit(
                      "label",
                      Array.isArray(val) ? val.join(",") : val,
                    );
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                },
              ],
              sortByFilter: [
                {
                  name: "Newest first",
                  default: true,
                  isDisabled: false,
                },
                {
                  name: "Oldest first",
                  isDisabled: false,
                },
                {
                  name: "Amount : Low to high",
                  isDisabled: false,
                },
                {
                  name: "Amount : High to low",
                  isDisabled: false,
                },
              ],
              sortValue: accountbalancestate,
              sortHandleChange: (val) => {
                handleSubmit("sort", val);
                setPage(GlobalConfiguration.lengthCheckOne);
                setaccountbalancestate(val);
              },
              isSearchClearAllDisabled: !(
                currentCategory?.length || LabelSearchText?.length
              ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: allTaxTxnLoading,
              loadingData: loadingData,
              setLoading: setLoadingData,
              isShowSortBy: true,
              isShowFilter: false,
            }}
          />
        </div>
        <div className="flex-1 overflow-y-auto overflow-x-hidden w-width-full flex justify-center pb-padding-xl Qsmd:pb-padding-base relative">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <div className="flex flex-col gap-gap-md py-padding-md w-width-full px-padding-md Qlg:px-padding-base overflow-y-auto">
            {allTaxTxnLoading ? (
              <div className="w-width-full h-[calc(100vh-var(--navbar-height)-var(--pagination-height))] flex items-center justify-center">
                <Loader />
              </div>
            ) : noTransactionsFromAPI ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-md m-auto">
                <div>
                  <img
                    src={
                      "https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg"
                    }
                    alt="no_pending_transaction"
                  />
                </div>
                <p className="text-sm text-text-primary">
                  There are no more transactions that require <br /> your
                  approval.
                </p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Go to dashboard"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() => navigate("/tax_transaction_dashboard")}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-sm m-auto">
                <div>
                  <img
                    src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                    alt="no data found"
                  />
                </div>
                <p className="text-sm text-text-primary">No data found.</p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() => {
                    handleClearFilters();
                  }}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : (
              tdsTransactionActionableData === undefined ||
              allTaxTxndata?.map((account) => {
                const overlay = getTxnOverlayConfig({
                  account,
                  loading,
                  openTxn: () => {
                    openBeneTxnDetailModal();
                    setTxnId(account.txn_id);
                  },
                  openAccountDrawer: () =>
                    SideDrawerOpen(account.tds_account_id, account.txn_id),
                });

                const alerts = [];

                const entries = [
                  [
                    {
                      type: "textSubtextX2",
                      text: `INR ${FormatAmount({
                        price: account?.amount || "0",
                      })}`,
                      isBold: true,
                      subText: "Amount",
                      textColor: "var(--settled)",
                      text1: account?.category || "Not available",
                      subText1: "Tax type",
                    },
                    {
                      type: "textSubtext",
                      text: accountNameStandardised(account?.tds_account_name),
                      subText: "Account name",
                    },

                    {
                      type: "cta",
                      text: account?.labels?.length
                        ? account.labels.join(", ")
                        : "Not assigned",
                      subText: "Labels",
                      onClick: (e) => {
                        if (
                          services?.includes("ALabel") &&
                          services?.includes("RLabel")
                        ) {
                          e.stopPropagation();
                          setLabeltxnid([account?.txn_id]);
                          setSelectedLabels(account?.labels || []);
                          setisLabelPopupOpen(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "ALabel,RLabel",
                            },
                          });
                        }
                      },
                    },
                  ],
                ];

                return (
                  <div
                    key={account.txn_id}
                    className="mx-auto flex Qlg:flex-row flex-col Qlg:max-w-[var(--tab-width-normal)] w-width-full z-z-index-content"
                  >
                    <CommonTransactionApprovalCard
                      overrideAutoLoader
                      whichBtnClicked={
                        approvalBtnClicked?.[account.txn_id] ?? "none"
                      }
                      accountApprovalPending={
                        account.lifecycle_status === "pending" &&
                        account.tds_account_approval_status === "pending" &&
                        !loading[account.txn_id]
                      }
                      entries={entries}
                      alerts={alerts}
                      cardState={overlay.cardState}
                      overlay1Text={overlay.overlay1Text}
                      overlay1Subtext={overlay.overlay1Subtext}
                      overlay1CtaText={overlay.overlay1CtaText}
                      overlay1CtaOnClick={overlay.overlay1CtaOnClick}
                      overlay1Cta1Text={overlay?.overlay1Cta1Text}
                      overlay1Cta1OnClick={overlay?.overlay1Cta1OnClick}
                      overlay1Cta1Color={overlay?.overlay1Cta1Color}
                      overlay2Text={overlay.overlay2Text}
                      overlay2Subtext={overlay.overlay2Subtext}
                      overlay1SubtextColor={overlay.overlay1SubtextColor}
                      approveClick={() => {
                        if (overlay.allowApproveReject) {
                          setApprovalBtnClicked((p) => {
                            return {
                              ...p,
                              [account.txn_id]: "approve",
                            };
                          });
                          handleTxnApproval(account.txn_id);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "ATDSTransaction, Admin",
                            },
                          });
                        }
                      }}
                      rejectClick={() => {
                        if (overlay.allowApproveReject) {
                          setApprovalBtnClicked((p) => {
                            return {
                              ...p,
                              [account.txn_id]: "reject",
                            };
                          });
                          handleOpenPopup(account.txn_id);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "ATDSTransaction, Admin",
                            },
                          });
                        }
                      }}
                      approveBtnText="Approve transaction"
                      rejectBtnText="Reject transaction"
                      ownerAccountNumber={account?.owner_account_bank_acc_no}
                      ownerAccountIfsc={account?.owner_account_ifsc_code}
                      ownerAccountNumberSubtext="Source account"
                      ownerAccountBalance={account?.owner_account_balance}
                      ownerAccountBalanceSubtext={` Balance - ${account.owner_account_balance_last_fetched_at_in_words}`}
                      ownerAccountBalanceOnClick={(e) =>
                        handleRefresh(
                          e,
                          account?.owner_account_id,
                          account?.owner_account_balance,
                        )
                      }
                      destinationAccountNumber={
                        account?.tds_account_bank_acc_no
                      }
                      destinationAccountIfsc={account?.tds_account_ifsc_code}
                      destinationAccountNumberSubtext="Destination account"
                      destinationAccountText={account?.tds_account_ifsc_code}
                      destinationAccountSubtext="IFSC code"
                      ctaBtn1Text="Additional details"
                      ctaBtn1OnClick={() => {
                        openBeneTxnDetailModal();
                        setTxnId(account.txn_id);
                      }}
                      ctaBtn2Text="Approval history"
                      ctaBtn2OnClick={() => OpenTimeline(account.txn_id)}
                      overlay1Icon={overlay.overlay1Icon}
                      overlay1IconColor={overlay.overlay1IconColor}
                    />
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div
          className={`h-pagination-height ${showInnerSearchBar ? "hidden " : " hidden Qsmd:block"} w-width-full `}
        ></div>
      </div>
    </>
  );
};

export default TaxationTransactionSingleApproval;
